module.exports = __webpack_public_path__ + "media/images/talent/feature02-3e2c1e79f0b643479977adebd1c953c2.png";